<template>
  <section class="error-page" v-if="errorObj">
    <div class="error-page__wrapper">
      <h2 class="error-page__code">{{ errorObj.title }}</h2>
      <BaseCaption
        v-if="errorObj.description"
        class="error-page__message"
        :text="errorObj.description"
      />
      <div class="error-page__btns">
        <BaseBtn
          customClass="default-text"
          :text="errorObj.leftButtonText"
          to="/"
        />
        <BaseBtn
          customClass="default-text"
          :text="errorObj.rightButtonText"
          to="/participants-page"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { Head } from '~/mixins/Head.js'
import { PageMixin } from '~/mixins/PageMixin'

export default {
  name: 'nuxt-error',
  props: ['error'],
  mixins: [Head,PageMixin],
  layout: 'default',
  computed: {
    errorObj() {
      // console.log(this.$store.state.data.errorObj);
      return this.$store.state.data.errorObj
    },
    metaObj() {
      // console.log(this.$store.state.data.errorObj.meta);
      return this.$store.state.data.errorObj.meta
    }
  },
  async created() {
      // this.$nuxt.error({ statusCode: 404})

      const {data} = await this.$axios.get('/not-found-page');

      this.$store.commit('data/SET_ERROR', { ... data })
  },
  // async created() {
  //   try {
  //     let {data} = {}
  //     await this.$axios.get('/not-found-page').catch(error => {
  //     data= error.response.data


  //   });
  //   this.$store.commit('data/SET_ERROR', { ...data })

  //   } catch (e) {
  //     this.$log(e)
  //   }
  // },

  mounted() {
    // this.$nuxt.error({});
     this.$log(this.error)
  }
}
</script>

<style lang="scss">
.error-page {
  &__wrapper {
    @include container;

    position: relative;
    padding: 66px 16px 166px;

    &::before {
      @include pseudo(252px, 159px, 'error-page-bg@mb.svg');
      @include horizontal-center;

      z-index: -1;
      bottom: 0;
    }
  }

  &__code {
    margin: 0 0 8px;
    color: #282830;
    font-family: $ToyotaType;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
  }

  &__message {
    margin: 0 0 19px;
    text-align: center;
  }

  &__btns {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .btn {
    width: 232px;

    &:not(:last-of-type) {
      margin-bottom: 20px;
    }
  }
}

@include media-min($tablet-width) {
  .error-page {
    &__wrapper {
      padding: 106px 25px 228px;

      &::before {
        bottom: 30px;
      }
    }

    &__code {
      margin-bottom: 16px;
      font-size: 36px;
      font-weight: 700;
      line-height: 36px;
    }

    &__message {
      margin-bottom: 17px;
    }

    &__btns {
      flex-direction: row;
      justify-content: center;
    }

    .btn {
      &:not(:last-of-type) {
        margin: 0 30px 0 0;
      }
    }
  }
}

@include media-min($desktop-width) {
  .error-page {
    &__wrapper {
      padding: 130px 60px 357px;

      &::before {
        @include pseudo(388px, 245px);

        bottom: 72px;
      }
    }

    &__code {
      margin-bottom: 18px;
      font-size: 44px;
      font-weight: 700;
      line-height: 48px;
    }

    &__message {
      margin-bottom: 20px;
    }

    .btn {
      width: 266px;

      &:not(:last-of-type) {
        margin: 0 36px 0 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// layouts/error.vue